import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { isArray, isDefined } from '@freelancer/utils';
import { SearchActiveContestsCollection } from './search-active-contests.types';

export function searchActiveContestsBackend(): Backend<SearchActiveContestsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },

    fetch: (authUid, ids, query, order) => ({
      endpoint: `contests/0.1/contests/active/`,
      params: {
        // projections
        entry_counts: 'true',
        full_description: 'true',
        job_details: 'true',
        upgrade_details: 'true',

        // filters
        contest_upgrades: getQueryParamValue(query, 'upgrades').map(upgrades =>
          isDefined(upgrades)
            ? Object.entries(upgrades)
                .filter(([_, isApplied]) => !!isApplied)
                .map(([upgrade, _]) => upgrade)
            : undefined,
        )[0],
        jobs: getQueryParamValue(query, 'skillIds')[0],
        max_avg_price: getQueryParamValue(query, 'prize', param =>
          param.condition === '<=' ? param.value : undefined,
        ).filter(isDefined)[0],
        min_avg_price: getQueryParamValue(query, 'prize', param =>
          param.condition === '>=' ? param.value : undefined,
        ).filter(isDefined)[0],
        offset: query?.searchQueryParams?.offset,
        query: query?.searchQueryParams?.query,
        reverse_sort:
          isArray(order) && order[0]
            ? order[0].direction === OrderByDirection.ASC || undefined
            : undefined,
        sort_field:
          isArray(order) && order[0]
            ? convertSortFieldApi(order[0].field)
            : undefined,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}

function convertSortFieldApi(sortField: string): string | undefined {
  switch (sortField) {
    case 'entryCount':
      return 'entry_count';
    case 'prize':
      return 'contest_prize_usd';
    case 'timeSubmitted':
      return 'time_updated';
    default:
      return undefined;
  }
}
